export enum ScreenViews {
  LANDING_SCREEN,
  CREATE_PASSWORD_SCREEN,
  LOGIN_SCREEN,
  ACTIVATE_CONFIRMATION_SCREEN,
  RESET_PASSWORD_CONFIRMATION_SCREEN,
  LOADING_SCREEN,
  MEMBERSHIP_CONSENTS,
}

export type TriggerActivationEmailRequest = {
  email: string
  sourceId: string
  minAgeConfirmation: boolean
  sendActivationEmail: boolean
  recaptcha: string
}

export type TriggerActivationEmailResponse = {
  message: string
  acid: string
}

export type TriggerActivationEmailErrorResponse = {
  errorCode: string
  statusCode: boolean
  validationErrors: Record<string, string>[]
}
